import {
  LuBookmark,
  LuChartBar,
  LuLayoutDashboard,
  LuLibrary,
  LuBookOpen,
  LuRefreshCw,
  LuTrophy,
  LuUser,
  LuUsers,
  LuZap,
} from 'react-icons/lu';

/** Icons for main app nav routes (desktop + drawer). */
export const APP_NAV_ICONS = {
  '/dashboard': LuLayoutDashboard,
  '/library': LuLibrary,
  '/hub': LuBookOpen,
  '/saved': LuBookmark,
  '/practice': LuZap,
  '/review': LuRefreshCw,
  '/analytics': LuChartBar,
  '/leaderboard': LuTrophy,
  '/teams': LuUsers,
  '/profile': LuUser,
};

export function NavRouteIcon({ path, className = 'app-nav-item-icon' }) {
  const Icon = APP_NAV_ICONS[path];
  if (!Icon) return null;
  return <Icon className={className} aria-hidden />;
}
